<video class="video-image" controls="controls">
	<source src="{{data.resource_url}}" type="video/mp4" />
</video>
